// eslint-disable-next-line no-undef
export default Object.freeze(__PROCESS_ENV_DATA__ || {});
